export const shouldLoad = () => document.querySelector('[data-controller="file-input"]') !== undefined;
